import { AutoMap } from '@automapper/classes';

export class SecuriteEntity {
    Id?: number;
    @AutoMap()
    EntreeZone!: number;
    @AutoMap()
    DureeExposition!: number;
    @AutoMap()
    Epi!: number;
    @AutoMap()
    MoyenObservation!: number;
    IsPose!: boolean;
}
